<template>
  <div class="wheel-picker">
    <main class="wheel-picker--main">
      <div class="wheel-picker--main--wheelbox">
        <div
          ref="parent"
          class="wheel"
          :style="{ width: wheelSize + 'px', height: wheelSize + 'px'}"
        >
          <img
            v-dragpicker="captureMovement"
            :src="image.src"
            class="wheel__image"
            :style="{...image.style, opacity}"
            draggable="false"
            @mousedown="onClick"
            @touchmove="onClick"
            @click.stop
          >
          <span
            v-dragpicker="captureMovement"
            class="wheel__picker"
            :style="{
              width: pickerSize + 'px',
              height: pickerSize + 'px',
              top: pickerTop + 'px',
              left: pickerLeft + 'px' }"
          />
        </div>
      </div>
      <div class="slider-box">
        <color-slider :color="color" />
        <hr class="sep">
      </div>
    </main>
  </div>
</template>

<script>
import chroma from 'chroma-js';
import ColorSlider from './ColorSlider';

export default {
  name: 'ColorWheel',
  components: {
    ColorSlider,
  },
  directives: {
    dragpicker: {
      bind(element, binding) {
        const mousemove = (e) => {
          binding.value(e);
          return false;
        };
        const mouseup = () => {
          document.removeEventListener('mousemove', mousemove);
          document.removeEventListener('mouseup', mouseup);
          return false;
        };

        const mousedown = (e) => {
          document.addEventListener('mousemove', mousemove);
          document.addEventListener('mouseup', mouseup);
          e.stopPropagation();
          return false;
        };

        element.addEventListener('mousedown', mousedown);
        // element.addEventListener('touchstart', mousedown);
        // element.addEventListener('touchmove', move);
      },
    },
  },
  data() {
    // eslint-disable-next-line
    const image = require('@/assets/color-picker-xl.png');

    return {
      wheelSize: 120,
      pickerSize: 15,
      pickerTop: 50,
      pickerLeft: 50,
      image: {
        src: typeof image === 'object' ? image.default : image, // This is to prevent [object object] webpack bug
        // src: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/435311/ryb.png',
        style: {
          width: '100%',
          height: 'auto',
          'user-select': 'none',
        //   transform: 'rotate(70deg)',
        },
      },
      color: {
        hsb: {
          h: 0, s: 0, b: 100,
        },
      },
    };
  },
  computed: {
    opacity() {
      const { hsb } = this.color;
      return hsb.b / 100;
    },
    hex() {
      // This is the real color we are selecting.
      // Converts the hsb to HEX code
      const { hsb } = this.color;
      const rawColor = chroma(hsb.h, hsb.s / 100, hsb.b / 100, 'hsv');
      return chroma(rawColor).hex();
    },
    pureHex() {
      // This is the pure color - without brightness
      // Converts the hsb to Pure HEX code
      const { hsb } = this.color;
      const rawColor = chroma(hsb.h, hsb.s / 100, 1, 'hsv');
      return chroma(rawColor).hex();
    },
  },
  watch: {
    'color.hsb': {
      handler(newValue, oldValue) {
        newValue.b = parseFloat(newValue.b);
        this.$emit('input', this.hex);
      },
      deep: true,
    },
  },
  methods: {
    hsbHue(value) {
      const hue = (value * 180) / Math.PI;

      let a,
        b,
        c,
        d;

      const from = [[0, 60], [60, 120], [120, 240], [240, 360]];
      const to = [[0, 120], [120, 180], [180, 240], [240, 360]];

      if (hue === 360) {
        return hue;
      }
      // eslint-disable-next-line
      for (const x in to) {
        if (hue >= to[x][0] && hue <= to[x][1]) {
          a = to[x][0]; // eslint-disable-line
          b = to[x][1]; // eslint-disable-line
          c = from[x][0]; // eslint-disable-line
          d = from[x][1]; // eslint-disable-line
        }
      }

      const hsbHue = c + (hue - a) * ((d - c) / (b - a));
      console.log(hsbHue);
      return hsbHue;
    },
    onClick(evt) {
      this.captureMovement(evt);
    },
    captureMovement(e) {
      const { parent } = this.$refs;

      const parentWidth = parent.clientWidth;
      // const parentHeight = parent.clientHeight;

      const offsetX = parent.getBoundingClientRect().left,
        offsetY = parent.getBoundingClientRect().top;

      const clientX = typeof e.clientX === 'undefined'
        ? e.changedTouches[0].clientX
        : e.clientX;

      const clientY = typeof e.clientY === 'undefined'
        ? e.changedTouches[0].clientY
        : e.clientY;

      let x = Math.round(clientX - offsetX),
        y = Math.round(clientY - offsetY);

      const maxR = parentWidth / 2;
      const rx = maxR - x,
        ry = maxR - y;

      let r = Math.sqrt(rx * rx + ry * ry);
      let angle = Math.atan2(ry, rx);

      angle = angle < 0 ? angle += Math.PI * 2 : angle;

      if (r > maxR) {
        r = maxR;
        x = (maxR - (maxR * Math.cos(angle)));
        y = (maxR - (maxR * Math.sin(angle)));
      }

      x = Math.round(x);
      y = Math.round(y);

      const h = this.hsbHue(angle);
      const s = Math.floor((r / maxR) * 100);

      this.pickerLeft = x - (this.pickerSize / 2);
      this.pickerTop = y - (this.pickerSize / 2);

      this.color.hsb.h = h;
      this.color.hsb.s = s;

      e.preventDefault();
      e.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
.wheel-picker{
  user-select: none;
}
.wheel{
    position: relative;
    margin: 0 auto;
    background-color: black;
    border-radius: 100px;
    &__image{
      -webkit-touch-callout: none;
      user-select: none;
      background-color: $gray-light;
    }
    &__picker{
        background-color: transparent;
        border-radius: 50%;
        border: 1px solid black;
        position: absolute;
        cursor: pointer;
        user-select: none;
        -webkit-touch-callout: none;
    }
}
</style>
